import { Action, configureStore, EnhancedStore } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';

import rootReducer, { RootState } from './rootReducer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createStore(): EnhancedStore<RootState, Action> {
    return configureStore({
        reducer: rootReducer,
    });
}

const store = createStore();

if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./rootReducer', () => {
        /* eslint-disable @typescript-eslint/no-var-requires */
        const newRootReducer = require('./rootReducer').default;
        /* eslint-enable @typescript-eslint/no-var-requires */
        store.replaceReducer(newRootReducer);
    });
}

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;

export default store;

export type AppStore = typeof store;

export type AppState = RootState;
